/* eslint-disable*/
import axios from 'axios';
console.log(process.env.VUE_APP_ENDPOINT);
var HOST = "";
if (process.env.VUE_APP_ENDPOINT === "local"){
    HOST = process.env.VUE_APP_LOCAL;
} else {
    HOST = process.env.VUE_APP_PROD;
}
const state = {
    documentGenerated: false,
    documentSaved: false,
    documentUploading: '',
    documentsAvailable: [
        {
            title:'',
            length:'',
            content:[
                {
                    level:0,
                    text:'',
                    emoji:''
                }
            ]
        }
    ],
    document:{
            title:'',
            length:'',
            content:[
                {
                    level:0,
                    text:'',
                    emoji:''
                }
            ]
        },
    documents:[]
}

const getters = {
    getAvailableDocuments:(state)=>{
        return state.documents;
    },
    getDocumentUploadStatus:(state)=>{
        return state.documentUploading;
    },
    getDocument:(state)=>{
        return state.document;
    },
    getDocumentSaved:(state)=>{
        return state.documentSaved;
    }

}

const actions = {
    saveDocument:({ commit, dispatch }, document) =>{
        axios.post(`${HOST}/api/save`, {body: document}).then((data) => {
            console.log(data);
            commit('setSaveDocument', document);
            dispatch('listDocuments', document.userid);
            return data;
        });
    },
    openDocument:({commit}, document)=>{
        console.log(document);
        commit('setOpenDocument', document);
    },
    deleteDocument:({commit, dispatch}, document)=>{
        console.log(document);
        axios.post(`${HOST}/api/deleteWhy`, {body:document}).then((data) => {
            console.log(data);
            // commit('setDeleteDocument', data.data.data);
            dispatch('listDocuments',document.userid);
            return
        });
    },
    listDocuments:({ commit }, user) =>{
        console.log(user);
        axios.post(`${HOST}/api/docs`, {body:user}).then((data) =>{
            console.log("GET DOCS: ", data.data.data);
            commit('setDocList', data.data.data);
            return
        });
    },
    updateDocument:({ commit, dispatch }, document) =>{
        axios.post(`${HOST}/api/update`, {body:document}).then((data) => {
            commit('setDocList', data.data.data);
            dispatch('listDocuments',document);
            return
        });
    }
}

const mutations = {
    setSaveDocument:(state, document)=>{
        console.log("save document", document);
        state.document = document;

    },
    setOpenDocument:(state, document)=>{
        state.document = document;
    },
    setDeleteDocument:(state, document)=>{

    },
    setDocList:(state, data)=>{
        state.documents = data;
    }

}

export default {
  state,
  getters,
  actions,
  mutations
}
